import { createContext } from "react";

const SelectionContext = createContext(null);

export default SelectionContext;
